import {PaperclipIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import type React from 'react'
import {memo, use} from 'react'

import {MarkdownEditorContext} from './MarkdownEditorContext'
import styles from './UploadButton.module.css'

/** The add files button, rendered inside the editor's border below the input. */
export const UploadButton = memo(() => {
  const {disabled, uploadButtonProps, fileDraggedOver, fileUploadProgress} = use(MarkdownEditorContext)
  if (!uploadButtonProps) return null

  const currentFileUpload = fileUploadProgress?.[0]
  const totalFileUploads = fileUploadProgress?.[1]
  const isUploading = Boolean(totalFileUploads)
  const fileUploadProgressString =
    totalFileUploads === 1
      ? 'Uploading your file...'
      : `Uploading your files... (${currentFileUpload}/${totalFileUploads})`

  return (
    <div className={styles.container}>
      <Button
        variant="invisible"
        loadingAnnouncement={isUploading ? fileUploadProgressString : undefined}
        leadingVisual={PaperclipIcon}
        loading={isUploading}
        size="small"
        className={styles.button}
        onMouseDown={(e: React.MouseEvent) => {
          // Prevent pulling focus from the textarea
          e.preventDefault()
        }}
        disabled={disabled}
        {...uploadButtonProps}
      >
        {fileDraggedOver ? 'Drop to add files' : 'Paste, drop, or click to add files'}
      </Button>
    </div>
  )
})
UploadButton.displayName = 'MarkdownEditor.UploadButton'
